import React, { useImperativeHandle, forwardRef } from 'react';
import Services from '../network/Services';
import konsole from '../network/konsole';
import { Constant } from '../utilities/Constant'
import { utilities } from '../utilities/utilities'

const OccuranceCom = (props, ref) => {
    let occurrenceId = 331;
    let primaryUserId = utilities.getSessionStoarge("primaryUserId");
    let subtenantId = utilities.getSessionStoarge("subtenantId");
    let info = { "emailId": "nitinnk@mailinator.com" }
    // const ResultSummary5="Based on your responses to the Legal Readiness Quiz, it sounds like your fiduciaries understand your perspective about what makes life worth living. This increases the odds that you will be able to achieve your goals. <br><br>Read on for detailed suggestions that can make your legal plan for retirement even better."
    // const ResultSummary10="Based on your responses to the Legal Readiness Quiz, your legal plan appears to cover the basics but may not fully reflect your perspective on what makes life worth living. This puts you at risk. <br><br> Read on for detailed suggestions that can make your legal plan for retirement even better. "
    // const ResultSummary14=" Based on your responses to the Legal Readiness Quiz, your documents contain some gaps that leave you exposed. This puts you at risk. <br><br> Read on for detailed suggestions for addressing each gap and making your legal plan for retirement even better.  "
    // const ResultSummary15="  Based on your responses to the Legal Readiness Quiz, your documents contain many gaps that leave you exposed. It’s critical to update your legal plan as soon as possible! <br><br>Read on for detailed suggestions for addressing each gap and making your legal plan for retirement even better. "
    const ResultSummary5 = '<p>Based on your responses to the Legal Readiness Quiz, it sounds like your fiduciaries understand your perspective about what makes life worth living. This increases the odds that you will be able to achieve your goals.  </p><p style="margin-bottom:20px;">Read on for detailed suggestions that can make your legal plan for retirement even better.</p>';
    const ResultSummary10 = '<p >Based on your responses to the Legal Readiness Quiz, your legal plan appears to cover the basics but may not fully reflect your perspective on what makes life worth living. This puts you at risk.</p><p style="margin-bottom:20px;">Read on for detailed suggestions that can make your legal plan for retirement even better.</p>';
    const ResultSummary14 = '<p >Based on your responses to the Legal Readiness Quiz, your documents contain some gaps that leave you exposed. This puts you at risk.</p><p style="margin-bottom:20px;">Read on for detailed suggestions for addressing each gap and making your legal plan for retirement even better.</p>';
    const ResultSummary15 = '<p >Based on your responses to the Legal Readiness Quiz, your documents contain many gaps that leave you exposed. It’s critical to update your legal plan as soon as possible!</p><p style="margin-bottom:20px;">Read on for detailed suggestions for addressing each gap and making your legal plan for retirement even better.</p>';
    
    useImperativeHandle(ref, () => ({
        calloccuranceIdfun
    }));

    const calloccuranceIdfun = (occurrenceId, subtenantId, info) => {
        konsole.log("calloccuranceIdfuncalloccuranceIdfun")
        let jsonobj = { "occurrenceId": occurrenceId, "isActive": true, "subtenantId": subtenantId }

        let promises = Services.getCommMediumPath(jsonobj)
        promises.then((res) => {
            konsole.log("getCommMediumPath", res)
            let { commChannelId, applicableEmailTempId, applicableTextTempId, subtenantName } = res?.data?.data[0];
            if (commChannelId == 1) { callEmailApiFunc(applicableEmailTempId, info, subtenantName) }
        }).catch((err) => {
            konsole.log("getCommMediumPath", err)
            if (err.response.status == 404) {
                let subtenantId = Constant.DEFAULT_SUBTENANTID_FOR_OCCURRENCE;
                calloccuranceIdfun(occurrenceId, subtenantId, info)
            }
        }).finally(() => {
            konsole.log("getCommMediumPath")
        })
    }
    //----------------------------------------------------------------------------------------------------

    //-EMAIL---------------------------------------------------------------------------------------------------

    const callEmailApiFunc = (TempalteId, info, subtenantName) => {
        konsole.log("callEmailApiFunc", TempalteId)
        let isActive = true;
        let result = Services.getEmailTemplate(TempalteId, isActive)
        result.then((res) => {
            konsole.log("getEmailTemplate", res)
          
            let responseData = res.data.data[0]
            konsole.log("responseData", responseData)
            sendEmailAPIFunc(responseData, info, subtenantName)
        }).catch((err) => {
            konsole.log("getEmailTemplate", err)
        }).finally(() => {
            konsole.log("getEmailTemplatefinally")
        })
    }

 

    //-Template---------------------------------------------------------------------------------------------------

    const templateReplacer = (templateData, info, subtenantName, type) => {
        // console.log("12templateData",templateData)
        let updatedTemplateData = templateData;
        let resultSummary=""
        resultSummary=info?.questionscore2;
        // console.log("infoinfoinfo",info,"props",props)
        // console.log("234resultSummary",resultSummary)
        if(props?.pageName=="Legal"){
             let resultSummaryString=(props.questionscore2>14)?ResultSummary15:(props.questionscore2>10)?ResultSummary14:(props.questionscore2>5)?ResultSummary10:ResultSummary5;
             resultSummary="<br>"+resultSummary+"<br>"+resultSummaryString
            //  console.log("Inside234resultSummary",resultSummary)
            }
        let username=info?.userDetails?.userName
        let capitalize1 = username.toUpperCase().slice(0,1) + username.slice(1)
        
        updatedTemplateData = updatedTemplateData?.
        replace('@@RESULT_MESSAGE',info?.restltText)
        .replace('@@SURVEYRESULTS',resultSummary)
        .replace('@@SUBTENANTNAME', subtenantName)
        .replace('@@EMOJI', info?.resultEmoji)
        updatedTemplateData = updatedTemplateData?.
        replace('@@FINALTHOUGHTS', info?.finalThoughts).
        replace('@@DIMENSION1',info?.dimension1).
        replace('@@DIMENSION2',info?.dimension2).
        replace('@@DIMENSION3',info?.dimension3).
        replace('@@INTRODUCTION',info?.introduction).
        replace('@@RESULTSOVERVIEW',info?.restltText).
        replace('@@USERNAME',capitalize1 )
        // console.log("updatedTemplateData",updatedTemplateData)
        return updatedTemplateData
    }

    const sendEmailAPIFunc = (responseData, info, subtenantName) => {
        let templateData = templateReplacer(responseData?.templateContent, 
            info, subtenantName, 'EMAIL')

        // console.log("templateData",templateData)
        let jsonobj = {
            "emailType": responseData?.templateType,
            "emailTo": info?.userDetails?.userEmail,
            "emailSubject": responseData?.emailSubject,
            "emailContent": templateData,
            "emailTemplateId": responseData?.templateId,
            "emailStatusId": 1,
            "emailMappingTable": "tblUserLinks",
            // "emailMappingTablePKId": allData.clientData.agentId,
            "createdBy": primaryUserId,
            "emailFromDisplayName":info?.emailFromDisplayName || ""
        }
        
        konsole.log("jsonobjjsonobj", JSON.stringify(jsonobj))
        let result = Services.PostEmailComNew(jsonobj)
        result.then((res) => {
            konsole.log("PostEmailCom", res)
            
        }).catch((err) => {
            konsole.log("PostEmailCom", err)
        }).finally(() => {
            konsole.log("PostEmailCom")
        })
    }
    
    return<></>
}

 export default forwardRef(OccuranceCom)